import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { configure } from "mobx";
import { createContextFactory } from "@tatum/utils";
import { OptionStore } from "./option";
import { PageStore } from "./page";
import { ApiKeyStore } from "./apiKey";
configure({
  enforceActions: "always"
});
/**
 * A collection of all available stores which gets available
 * through the custom hook useStores in your function components.
 *
 * @see https://mobx.js.org/best/store.html#combining-multiple-stores
 */

var RootStore = /*#__PURE__*/function () {
  _createClass(RootStore, [{
    key: "context",
    get: function get() {
      return this.contextMemo ? this.contextMemo : this.contextMemo = createContextFactory(this);
    }
  }]);

  function RootStore() {
    _classCallCheck(this, RootStore);

    this.optionStore = void 0;
    this.pageStore = void 0;
    this.apiKeyStore = void 0;
    this.contextMemo = void 0;
    this.optionStore = new OptionStore(this);
    this.pageStore = new PageStore(this);
    this.apiKeyStore = new ApiKeyStore(this);
  }

  _createClass(RootStore, null, [{
    key: "StoreProvider",
    get: function get() {
      return RootStore.get.context.StoreProvider;
    }
  }, {
    key: "get",
    get: function get() {
      return RootStore.me ? RootStore.me : RootStore.me = new RootStore();
    }
  }]);

  return RootStore;
}();

RootStore.me = void 0;

var useStores = function useStores() {
  return RootStore.get.context.useStores();
};

export { RootStore, useStores };